import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./autoConfigurator.html";
import { getLocalStorage, getClientId, getApiPrefixURL } from '../utils/util';
import { httpGet } from '../services/service';
import { ENV_TYPES } from '../utils/appConstants';
const {
  SANDBOX,
  PRODUCTION
} = ENV_TYPES;
class AutoConfigurator extends LightningElement {
  constructor(...args) {
    super(...args);
    this.envType = SANDBOX;
    this.isOrgDataLoaded = false;
    this.isAPIExecuted = false;
    this.statusMessage = void 0;
    this.value = SANDBOX;
    this.handleChange = event => {
      this.envType = event.detail.value;
    };
    this.getSalesforceSession = e => {
      const salesforceUrl = this.envType === PRODUCTION ? 'https://login.salesforce.com' : 'https://test.salesforce.com';
      const hostName = window.location.hostname;
      const clientId = getClientId(hostName);
      console.log('configurator clientId: ', clientId);
      const loginUrl = `${salesforceUrl}/services/oauth2/authorize?response_type=token&client_id=${escape(clientId)}&redirect_uri=${window.location.origin}/oauthcallback.html&prompt=login%20consent`;
      console.log(`loginUrl :: ${loginUrl}`);
      // -- loginUrl opens in popup window
      const centerLeft = (window.screen.availWidth - 1000) / 2;
      const centerTop = (window.screen.availHeight - 800) / 2 - 50;
      window.open(loginUrl, 'demo_win', `width=1000 ,height=750,left=${centerLeft},top=${centerTop}`);
      window.addEventListener('storage', () => {
        if (!this.isAPIExecuted) {
          this.getOAuthCallbackResponse();
          this.isAPIExecuted = true;
        }
      });
    };
    this.getOAuthCallbackResponse = () => {
      const localThisState = this;
      localThisState.isOrgDataLoaded = true;
      let storedSessionInfo = JSON.parse(getLocalStorage('configSessionInfo'));
      const statusMailId = this.template.querySelector('lightning-input[data-my-id="emailId"]').value;
      const sforceSessionInfo = `{"acessToken":"${storedSessionInfo.access_token}","serviceEndpoint":"${storedSessionInfo.instance_url}/services/Soap/u/59.0/"}`;
      httpGet(`${getApiPrefixURL()}/svmx/a360/configurator/seedData`, sforceSessionInfo, statusMailId).then(function (data) {
        const {
          status,
          entity
        } = data;
        const response = JSON.parse(entity);
        const {
          message
        } = response;
        localThisState.statusMessage = message;
        if (status === 200) {
          localThisState.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'block';
          setTimeout(() => {
            localThisState.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'none';
          }, 5000);
        } else {
          localThisState.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'block';
          setTimeout(() => {
            localThisState.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'none';
          }, 5000);
        }
        localThisState.isAPIExecuted = false;
      }).catch(function (err) {
        console.log('Seed data loading is failed due to error:', err);
      }).finally(() => {
        localThisState.isOrgDataLoaded = false;
      });
    };
    this.closeToastMessage = () => {
      this.template.querySelector('div[data-my-id="toastMessageDiv"]').style.display = 'none';
    };
    this.closeToastErrorMessage = () => {
      this.template.querySelector('div[data-my-id="toastErrorMessageDiv"]').style.display = 'none';
    };
  }
  get options() {
    return [{
      label: 'Sandbox',
      value: SANDBOX
    }, {
      label: 'Production',
      value: PRODUCTION
    }];
  }
}
_registerDecorators(AutoConfigurator, {
  fields: ["envType", "isOrgDataLoaded", "isAPIExecuted", "statusMessage", "value", "handleChange", "getSalesforceSession", "getOAuthCallbackResponse", "closeToastMessage", "closeToastErrorMessage"]
});
export default _registerComponent(AutoConfigurator, {
  tmpl: _tmpl
});